import React, { useState } from 'react'
import { PopupWidget, InlineWidget, PopupModal } from 'react-calendly';
import emailjs from '@emailjs/browser';
import businessInfo from '../businessInfo';


const Contact = () => {
  const [step, setStep] = useState(1);

  const [submitted, setSubmitted] = useState(false);
  // Calendly Popup State
  const [calendlyOpen, setCalendlyOpen] = useState(false);

  const formTypes = [
    {
      id: "kanzlei",
      label: "Steuerkanzlei / Lohnbüro",
      desc: "Outsourcing-Partner gesucht",
    },
    { id: "kmu", label: "KMU / Unternehmen", desc: "Direkte Lohnabrechnung" },
    {
      id: "probemandat",
      label: "Probemandat testen",
      desc: "Kostenlose Testabrechnung",
    },
    { id: "beratung", label: "Beratungsgespräch", desc: "15 Min. kostenlos" },
  ];

  const [formData, setFormData] = useState({
    type: "",
    firm: "",
    contact: "",
    email: "",
    employees: "",
    budget: "",
    message: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
    name: formData.contact || 'Ansprechpartner',  // Fallback
    firma: formData.firm || 'Ihrem Unternehmen',
    email: formData.email || '',
    type: formData.type || '',
    message: formData.message || '',  // leer = kein Problem
    budget: formData.budget || '',
    abrechnungen: Number(formData.employees) || 0,
    time: new Date().toLocaleString('de-DE'),
    // KEINE Boolean-Flags mehr - nicht nötig!
  }

    emailjs
      .send(
        "service_9vpc79h", // dein Service ID
        "template_6k02zdp", // dein Template ID
        templateParams,
        "wyHaOSTNWkGDc_3hf", // dein Public Key
      )
      .then(
        () => {
          console.log("Email sent");
          setSubmitted(true);
        },
        (err) => {
          console.error("Email failed", err);
        },
      );
  };


  // Step-Handler: Step direkt nach Auswahl setzen
  const handleTypeSelect = (typeId) => {
    setFormData((prev) => ({ ...prev, type: typeId }));
    setStep(2);
  };

  if (submitted) {
    return (
      <section className="max-w-4xl mx-auto py-32 px-6 text-center">
        <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-16 rounded-3xl shadow-2xl">
          <div className="w-24 h-24 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-8">
            <svg
              className="w-12 h-12 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h2 className="text-4xl font-bold mb-6">Perfekt! Anfrage erhalten</h2>
          <p className="text-xl mb-12 max-w-2xl mx-auto leading-relaxed">
            Sie hören <strong>in Kürze</strong> von uns.
            Bereiten Sie sich auf Ihr unverbindliches Angebot vor.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#home"
              className="bg-white text-green-600 px-10 py-4 rounded-xl font-bold hover:bg-gray-100 transition"
            >
              Zurück zur Startseite
            </a>
            <button
              onClick={() => {
                setStep(1);
                setFormData({});
                setSubmitted(false);
              }}
              className="border-2 border-white px-10 py-4 rounded-xl font-bold hover:bg-white hover:text-green-600 transition"
            >
              Neue Anfrage
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="max-w-4xl mx-auto py-24 px-6">
      {/* Header */}
      <div className="text-center mb-20">
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-900 to-blue-700 bg-clip-text text-transparent mb-6">
          Persönliche Beratung vereinbaren
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
          15 Minuten – unverbindlich – individuell. Erhalten Sie Ihr
          maßgeschneidertes Angebot.
        </p>
      </div>

      {/* Multi-Step Form */}
      <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 max-w-2xl mx-auto">
        {/* Step 1: Typ */}
        {step === 1 && (
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
              Was möchten Sie?
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              {formTypes.map((type) => (
                <button
                  key={type.id}
                  onClick={() => handleTypeSelect(type.id)}
                  className={`p-8 rounded-2xl border-2 transition-all hover:shadow-xl hover:-translate-y-1 ${
                    formData.type === type.id
                      ? "border-blue-500 bg-blue-50 shadow-xl ring-4 ring-blue-100"
                      : "border-gray-200 hover:border-blue-300"
                  }`}
                >
                  <div className="text-3xl mb-4">📋</div>
                  <h4 className="font-bold text-lg text-gray-900 mb-2">
                    {type.label}
                  </h4>
                  <p className="text-sm text-gray-600">{type.desc}</p>
                </button>
              ))}
            </div>
            <div className="pt-8 border-t border-gray-200 text-center">
              <p className="text-sm text-gray-500 mb-4">
                Oder direkt kontaktieren:
              </p>
              <a
                href="tel:+49123456789"
                className="text-blue-600 hover:text-blue-700 font-semibold text-lg"
              >
                ☎️ {businessInfo.phone}
              </a>
            </div>
          </div>
        )}

        {/* Step 2: Details */}
        {step === 2 && (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Kanzlei / Firmenname <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                required
                value={formData.firm}
                onChange={(e) =>
                  setFormData({ ...formData, firm: e.target.value })
                }
                className="w-full p-4 border border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition"
                placeholder="z.B. Müller Steuerberatung GmbH"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Ansprechpartner <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                required
                value={formData.contact}
                onChange={(e) =>
                  setFormData({ ...formData, contact: e.target.value })
                }
                className="w-full p-4 border border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition"
                placeholder="Max Mustermann"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                E-Mail <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                required
                value={formData.email || ""}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                className="w-full p-4 border border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition"
                placeholder="max@mueller-steuer.de"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Anzahl Mitarbeiter / Abrechnungen
              </label>
              <input
                type="number"
                value={formData.employees}
                onChange={(e) =>
                  setFormData({ ...formData, employees: e.target.value })
                }
                className="w-full p-4 border border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition"
                placeholder="z.B. 15"
              />
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">
                  Budget pro Monat
                </label>
                <select
                  value={formData.budget}
                  onChange={(e) =>
                    setFormData({ ...formData, budget: e.target.value })
                  }
                  className="w-full p-4 border border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500"
                >
                  <option value="">Bitte wählen...</option>
                  <option value="< 500€">&lt; 500€</option>
                  <option value="500-1500€">500-1500€</option>
                  <option value="> 1500€">&gt; 1500€</option>
                  <option value="keine Angabe">Keine Angabe</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-900 mb-2">
                  Starttermin
                </label>
                <input
                  type="date"
                  className="w-full p-4 border border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Besondere Anforderungen
              </label>
              <textarea
                rows="4"
                value={formData.message}
                onChange={(e) =>
                  setFormData({ ...formData, message: e.target.value })
                }
                className="w-full p-4 border border-gray-300 rounded-xl focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition resize-vertical"
                placeholder="z.B. DATEV-Integration, Baulohnabrechnung, Probemandat für 1 Monat..."
              />
            </div>

            {/* Progress & Buttons */}
            <div className="flex flex-col gap-3 pt-6 border-t border-gray-200 sm:flex-row sm:items-center sm:justify-between">
              <div className="flex flex-row items-center justify-between gap-2 w-full sm:w-auto">
                <button
                  type="button"
                  onClick={() => setStep(step - 1)}
                  className="px-6 py-3 text-sm font-semibold text-gray-900 hover:text-blue-600 transition w-1/3 sm:w-auto"
                >
                  Zurück
                </button>
                <div className="flex items-center gap-2 text-sm text-gray-500 w-1/3 sm:w-auto justify-center">
                  <div className="w-8 h-1 bg-blue-500 rounded-full" />
                  <div className="w-8 h-1 bg-gray-200 rounded-full" />
                  <div className="w-8 h-1 bg-gray-200 rounded-full" />
                </div>
              </div>
              <button
                type="submit"
                className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-4 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl hover:from-blue-700 transition-all w-full sm:w-auto"
              >
                Angebot anfordern →
              </button>
            </div>
          </form>
        )}

        {/* Step 3: Success wäre hier, aber wir haben submitted-State */}
      </div>

      {/* Alternative Kontakt */}
      <div className="mt-20 grid md:grid-cols-3 gap-8 text-center">
        {/* WhatsApp Box */}
        <a
          href={`https://wa.me/${businessInfo.phone.replace(/[^\d]/g, "")}`}
          target="_blank"
          rel="noopener noreferrer"
          className="block p-8 bg-green-50 rounded-2xl hover:shadow-lg transition cursor-pointer"
        >
          <div
            className="flex items-center justify-center mb-4"
            style={{ height: "48px" }}
          >
            {/* WhatsApp SVG Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
              fill="currentColor"
              className="w-12 h-12 text-green-600"
              style={{ display: "block" }}
            >
              <path d="M16 3C9.373 3 4 8.373 4 15c0 2.385.668 4.678 1.934 6.684L4 29l7.488-1.902A12.96 12.96 0 0 0 16 27c6.627 0 12-5.373 12-12S22.627 3 16 3zm0 22c-1.98 0-3.917-.52-5.61-1.505l-.4-.23-4.45 1.13 1.19-4.34-.26-.42A9.93 9.93 0 0 1 6 15c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10zm5.13-7.47c-.28-.14-1.65-.81-1.9-.9-.25-.09-.43-.14-.61.14-.18.28-.7.9-.86 1.08-.16.18-.32.2-.6.07-.28-.14-1.18-.44-2.25-1.4-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.34.42-.51.14-.17.18-.29.28-.48.09-.19.05-.36-.02-.5-.07-.14-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47-.16-.01-.35-.01-.54-.01-.19 0-.5.07-.76.36-.26.28-1 1-.97 2.43.03 1.43.98 2.81 1.12 3 .14.19 2.01 3.07 4.89 4.18.68.26 1.21.41 1.62.53.68.22 1.3.19 1.79.12.55-.08 1.65-.67 1.89-1.32.23-.65.23-1.21.16-1.32-.07-.11-.25-.18-.53-.32z" />
            </svg>
          </div>
          <h4 className="font-bold text-xl mb-2">WhatsApp Chat</h4>
          <div className="text-2xl font-bold text-green-900 hover:text-green-700">
            {businessInfo.phone}
          </div>
          <p className="text-sm text-gray-600 mt-2">Mo–Fr 9–18 Uhr</p>
        </a>
        {/* E-Mail Box */}
        <a
          href={`mailto:${businessInfo.email}`}
          className="block p-8 bg-blue-50 rounded-2xl hover:shadow-lg transition cursor-pointer"
        >
          <div className="text-3xl mb-4">📧</div>
          <h4 className="font-bold text-xl mb-2">E-Mail</h4>
          <div className="text-lg font-bold text-blue-900 hover:text-blue-700">
            {businessInfo.email}
          </div>
        </a>
        {/* Termin buchen Box */}

        <button
          type="button"
          onClick={() => setCalendlyOpen(true)}
          className="block w-full p-8 bg-yellow-50 rounded-2xl hover:shadow-lg transition cursor-pointer"
        >
          <div className="text-3xl mb-4">📅</div>
          <h4 className="font-bold text-xl mb-2">Termin buchen</h4>
          <div className="text-lg font-bold text-yellow-900 hover:text-yellow-700">
            Calendly
          </div>
        </button>
        {/* Calendly PopupWidget */}
        <PopupModal
          url="https://calendly.com/anfragen-payroll-experten/30min"
          rootElement={document.body}
          onModalClose={() => setCalendlyOpen(false)}
          open={calendlyOpen}
          prefill={{}}
          pageSettings={{
            backgroundColor: "ffffff",
            hideEventTypeDetails: false,
            hideLandingPageDetails: false,
            primaryColor: "fbbf24",
            textColor: "1f2937",
          }}
        />
      </div>
    </section>
  );
};

export default Contact
